import { XIcon } from '@langchain/untitled-ui-icons';

import { ReactNode } from 'react';

import { IconButton, type IconButtonProps, Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export interface FloatingActionBarProps {
  label: string | JSX.Element;
  children: ReactNode;
  onCancel: () => void;
  cancelButtonProps?: Partial<IconButtonProps>;
}

export const FloatingActionBar = ({
  label,
  children,
  onCancel,
  cancelButtonProps,
}: FloatingActionBarProps) => {
  return (
    <div className="fixed bottom-10 left-1/2 z-10 -translate-x-1/2 border-primary bg-primary dark:bg-tertiary">
      <div
        className={cn(
          'flex items-center gap-10 rounded-xl border py-4 pl-6 pr-3 shadow-md'
        )}
      >
        <Text variant="h3">{label}</Text>
        <div className="flex items-center gap-2">
          {children}
          <IconButton
            variant="plain"
            color="secondary"
            icon={XIcon}
            label="Cancel"
            iconClassName="size-5"
            className="bg-tertiary"
            {...cancelButtonProps}
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
};
